"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var generalPdfSettings = {
  defaultTemplateSettings: {
    logoElement: '',
    htmlTemplatePath: '/sitecore/content/Oticon/main/Settings/Mail Templates/TEST/favoriteListTemplatev2',
    MailTemplatePath: '/TEST/PDFTest',
    EmailReceiver: 'emailReceiver@oticon.com',
    emailSender: 'emailSender@oticon.com',
    hcpEmail: 'hcpTestEmail@oticon.com',
    pdfName: 'Test.pdf',
    languageCode: 'en',
    emailBodyContent: '',
    customStyle: '',
    footer: '',
    pdfContent: '',
    header: '',
    emailTitle: '',
    name: ''
  },
  pdfConfigSettings: {
    getPdfEndpoint: '/webservices/pdfcreator.svc/DownloadPdf',
    sendPdfEndpoint: '/webservices/pdfcreator.svc/SendPdfAsMail',
    responseType: 'blob',
    method: 'POST',
    contentType: 'application/pdf'
  }
};
var _default = generalPdfSettings;
exports["default"] = _default;